import { Layout } from "providers/Layout";
import { useEffect, useState } from "react";
import { Button, ButtonSize, ButtonVariant, Input } from "shared/components";
import { BreadCrumbs } from "shared/components/BreadCrumbs";
import { Card } from "shared/components/Card";
import { Tabs } from "shared/components/Tabs";
import { WithGoogleAnalyticsId } from "views/settings-integration/integrations/google-analytics/types";
import { useSettingsController } from "views/settings-integration/controller";

export const GoogleAnalyticsView = () => {
  const { updateSettings, currentSettings, isUpdateSettingsPending } =
    useSettingsController();

  const [activeTab, setActiveTab] = useState<"General">("General");
  const [settings, setSettings] = useState(
    currentSettings.google as WithGoogleAnalyticsId
  );

  useEffect(() => {
    if (currentSettings.google.googleAnalyticsId)
      setSettings(currentSettings.google as WithGoogleAnalyticsId);
  }, [currentSettings.google.googleAnalyticsId]);

  const hasChanges =
    JSON.stringify(settings) !== JSON.stringify(currentSettings.google);

  return (
    <Layout
      header={
        <>
          <div className="flex items-center justify-between border-b border-alpha-40 px-3 md:px-6 pb-3">
            <BreadCrumbs
              crumbs={[
                {
                  title: "Settings",
                  href: "/settings"
                },
                {
                  title: "Integration",
                  href: "/settings/integration"
                },
                {
                  title: "Google Analytics",
                  href: "/settings/integration/google-analytics"
                }
              ]}
            />
          </div>
          <h1 className="text-xl font-bold text-content-1000 p-6 pb-3">
            Google Analytics
          </h1>
        </>
      }
      footer={
        <div className="flex justify-end gap-2">
          <Button
            variant={ButtonVariant.BASE}
            size={ButtonSize.SM}
            onClick={() =>
              setSettings(currentSettings.google as WithGoogleAnalyticsId)
            }
            className="w-[125px]"
            disabled={!hasChanges || isUpdateSettingsPending}
          >
            Cancel
          </Button>
          <Button
            variant={ButtonVariant.PRIMARY}
            size={ButtonSize.SM}
            onClick={() => updateSettings(settings)}
            className="w-[125px]"
            disabled={!hasChanges || isUpdateSettingsPending}
            loading={isUpdateSettingsPending}
          >
            Save
          </Button>
        </div>
      }
    >
      <div className="mb-4">
        <Tabs
          tabs={["General"]}
          displayMap={{
            General: "General"
          }}
          variant="underline"
          selected={activeTab}
          setActiveTab={(t) => setActiveTab(t)}
        />
      </div>

      <Card className="w-full p-6 max-w-[800px]">
        <p className="font-bold">Credentials</p>

        <div className="mt-6 border-t border-alpha-40 pt-6">
          <Input
            value={settings.googleAnalyticsId || ""}
            onChange={(e) =>
              setSettings({ ...settings, googleAnalyticsId: e.target.value })
            }
            label="GA account ID"
            id="gId"
            placeholder="G-XYZ"
            required
          />
        </div>
      </Card>
    </Layout>
  );
};
